<template>
  <div class="card bg-white border-0 rounded-3 mb-4">
    <div class="card-body p-4">
      <form @submit.prevent="validateForm">
        <div class="row">
          <div class="col-lg-4 col-sm-6">
            <div class="form-group mb-4" v-if="itemsCompany">
              <label class="label text-secondary">Empresa/Institución</label>
              <select class="form-select form-control h-45" aria-label="Default select example"
                v-model="player.companyId" @change="clearError('companyId')">
                <option :value="null">-- Seleccionar --</option>
                <option :value="company.id" v-for="(company, i) of itemsCompany" :key="i">
                  {{ company.name }}
                </option>
              </select>
              <div class="input-error">{{ errors.companyId }}</div>
            </div>
          </div>
          <div class="col-lg-4 col-sm-6">
            <div class="form-group mb-4">
              <label class="label text-secondary">Username (correo)</label>
              <input type="text" class="form-control h-45" placeholder="Ingresar el username" v-model.trim="player.email"
                @input="clearError('email')" />
              <div class="input-error">{{ errors.email }}</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-4 col-sm-6">
            <div class="form-group mb-4">
              <label class="label text-secondary">Nombres</label>
              <input type="text" class="form-control h-45" placeholder="Ingresar el nombre del usuario"
                v-model.trim="player.firstName" @input="clearError('firstName')" />
              <div v-if="errors.firstName" class="input-error">
                {{ errors.firstName }}
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-sm-6">
            <div class="form-group mb-4">
              <label class="label text-secondary">Apellidos</label>
              <input type="text" class="form-control h-45" placeholder="Ingresar el apellido del usuario"
                v-model.trim="player.lastName" @input="clearError('lastName')" />
              <div v-if="errors.lastName" class="input-error">
                {{ errors.lastName }}
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-4 col-sm-6">
            <div class="form-group mb-4">
              <label class="label text-secondary">Contraseña (opcional)</label>
              <input type="text" class="form-control h-45" placeholder="Ingresar una contraseña"
                v-model.trim="player.password" @input="clearError('password')" />
              <div v-if="errors.password" class="input-error">
                {{ errors.password }}
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-sm-6">
            <div class="form-group mb-4">
              <label class="label text-secondary">¿Cambiar contraseña al 1er login?</label>
              <div class="form-check form-switch">
                <input class="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckDefault"
                  v-model="player.forcePasswordChange" />
                <label class="form-check-label" for="flexSwitchCheckDefault"></label>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-4 col-sm-6">
            <div class="form-group mb-4" v-if="itemsDocumentType">
              <label class="label text-secondary">Tipo documento (opcional)</label>
              <select class="form-select form-control h-45" aria-label="Default select example"
                v-model="player.documentTypeId" @change="clearError('documentTypeId')">
                <option :value="null">-- Seleccionar --</option>
                <option :value="documentType.id" v-for="(documentType, i) of itemsDocumentType" :key="i">
                  {{ documentType.name }}
                </option>
              </select>
              <div class="input-error">{{ errors.documentTypeId }}</div>
            </div>
          </div>
          <div class="col-lg-4 col-sm-6">
            <div class="form-group mb-4">
              <label class="label text-secondary">Documento de identidad (opcional)</label>
              <input type="text" class="form-control h-45" placeholder="Ingresar el username" v-model.trim="player.documentNumber"
                @input="clearError('documentNumber')" />
              <div class="input-error">{{ errors.documentNumber }}</div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-4 col-sm-6">
            <div class="form-group mb-4">
              <label class="label text-secondary">Teléfono/Celular (opcional)</label>
              <input type="text" class="form-control h-45" placeholder="Ingresar el Teléfono/Celular" v-model.trim="player.phoneNumber"
                @input="clearError('phoneNumber')" />
              <div class="input-error">{{ errors.phoneNumber }}</div>
            </div>
          </div>
          <div class="col-lg-4 col-sm-6">
            <div class="form-group mb-4">
            </div>
          </div>          
        </div>

        <div class="row" v-if="isEditMode">
          <h3 class="mb-0">Datos adicionales</h3>
        </div>
        <br />
        <div class="row" v-if="isEditMode">
          <div class="col-lg-4 col-sm-6">
            <div class="form-group mb-4">
              <label class="label text-secondary">Alias</label>
              <input type="text" class="form-control h-45" placeholder="Ingresar el Alias" v-model.trim="player.alias"
                @input="clearError('alias')" :disabled="!canEditAlias" />
              <!--  <div v-if="errors.alias" class="input-error">
                {{ errors.alias }}
              </div> -->
            </div>
          </div>
          <div class="col-lg-4 col-sm-6">
            <div class="form-group mb-4">
              <label class="label text-secondary">Fecha de Nacimiento</label>
              <VueDatePicker v-model="player.birthdate" placeholder="Selecciona una fecha" format="dd/MM/yyyy"
                :format-locale="es" :enable-time-picker="false" @update:model-value="clearError('birthdate')" teleport
                :disabled="!canEditBirthdate" />
              <!--  <div class="input-error">{{ errors.birthdate }}</div>
            </div> -->
            </div>
          </div>
        </div>
        <div class="row" v-if="isEditMode">
          <div class="col-lg-4 col-sm-6">
            <div class="form-group mb-4">
              <label class="label text-secondary">Motivos de participación</label>
              <textarea rows="4" style="resize: none" class="form-control text-dark no-resize"
                placeholder="Ingresar Motivo de participación" v-model.trim="player.participationReasons"
                @input="clearError('participationReasons')" :disabled="!canEditParticipationReasons"></textarea>
              <!--  <div v-if="errors.participationReasons" class="input-error">
                {{ errors.participationReasons }}
              </div> -->
            </div>
          </div>
          <div class="col-lg-4 col-sm-6">
            <div class="form-group mb-4">
              <label class="label text-secondary">Otros</label>
              <input type="text" class="form-control h-45" placeholder="Otros" v-model.trim="player.otherInfo"
                @input="clearError('alias')" :disabled="!canEditAlias" />
            </div>
          </div>
        </div>

        <div class="col-lg-6">
          <div class="form-group mb-4 p-4 bg-body d-sm-flex justify-content-between align-items-center rounded-3">
            <div class="d-sm-flex align-items-center mb-3 mb-sm-0 me-lg-3 position-relative">
              <div class="me-md-5 pe-xxl-5 mb-3 mb-sm-0">
                <h4 class="body-font fs-15 fw-semibold text-body">Tu foto</h4>
              </div>

              <!-- Image Container -->
              <div class="position-relative d-inline-block">
                <img class="rounded-4 wh-75 ms-3 ms-lg-0 rounded-circle" :src="profileUrl" alt="user"
                  style="width: 125px; height: 125px; object-fit: cover" />

                <button type="button" class="btn btn-sm btn-light position-absolute bottom-0 end-0 rounded-circle"
                  style="transform: translate(25%, 25%)" @click="triggerFileInput">
                  <span class="material-symbols-outlined">add_a_photo</span>
                </button>

                <!-- Hidden file input -->
                <input type="file" ref="fileInput" accept="image/*" @change="onFileChange" class="d-none" />
              </div>
            </div>

            <div class="d-flex ms-sm-3 ms-md-0">
              <button type="button" class="btn bg-danger bg-opacity-10 text-danger fw-semibold"
                @click="resetProfilePhoto">
                Eliminar
              </button>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-12">
            <div class="d-flex flex-wrap gap-3">
              <RouterLink to="/players">
                <button type="button"
                  class="btn btn-danger bg-danger bg-opacity-10 text-danger border-0 fw-semibold py-2 px-4">
                  Cancelar
                </button>
              </RouterLink>
              <button class="btn btn-primary bg-primary bg-opacity-10 text-primary border-0 fw-semibold py-2 px-4"
                type="submit" :disabled="isLoading">
                <span v-if="!isLoading">{{
                  player.id == 0 ? "Crear Jugador" : "Actualizar Jugador"
                }}</span>
                <span class="spinner-border spinner-border-sm me-2" aria-hidden="true" v-if="isLoading"></span>
                <span role="status" v-if="isLoading">Procesando...</span>
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script lang="ts">
import { playerSchema } from "@/schemas/playerSchema";
import { defineComponent, ref, onMounted } from "vue";
import api from "@/services/api";
import { useToast } from "vue-toastification";
import { useRouter, useRoute } from "vue-router";
import { COMPANY_TYPES, PLAYER_PROFILE_PHOTO_DEFAULT } from "@/utils/constants";
import moment from "moment";
import { es } from "date-fns/locale";

export default defineComponent({
  name: "CreatePlayer",
  components: {},

  setup() {
    const toast = useToast();
    const route = useRoute();
    const router = useRouter();
    const isLoading = ref(false);
    const profileUrl = ref<string>("");
    const profileUrlDefault = ref<string>("");
    const fileInput = ref<HTMLInputElement | null>(null);
    const isEditMode = ref(false);
    const itemsCompany = ref<any[]>([]);
    const itemsDocumentType = ref<any[]>([]);
    const canEditAlias = ref(false);
    const canEditBirthdate = ref(false);
    const canEditParticipationReasons = ref(false);
    const player = ref({
      id: 0,
      email: null,
      oldEmail: null,
      newEmail: null,
      firstName: null,
      lastName: null,
      companyId: null,
      profilePhoto: null,
      urlProfilePhoto: null,
      birthdate: null,
      alias: null,
      participationReasons: null,
      password: null,
      force_password_change: true,
      fullName: null,
      flagCambioImagen: false,
      forcePasswordChange: false,
      otherInfo: null,
      documentTypeId: null,
      documentNumber: null,
      phoneNumber: null
    });
    const errors = ref<Record<string, string>>({});

    onMounted(async () => {
      await getCompanies();
      await getDocumentType();
      var idPlayer = route.params.id;
      if (idPlayer) {
        await getPlayerById(idPlayer);
      } else {
        profileUrlDefault.value = `${process.env.VUE_APP_API_URL}/${PLAYER_PROFILE_PHOTO_DEFAULT}`;
        profileUrl.value = `${process.env.VUE_APP_API_URL}/${PLAYER_PROFILE_PHOTO_DEFAULT}`;
      }
      if (player.value.alias) {
        canEditAlias.value = true;
      }
      if (player.value.birthdate) {
        canEditBirthdate.value = true;
      }
      if (player.value.participationReasons) {
        canEditParticipationReasons.value = true;
      }
      profileUrlDefault.value = `${process.env.VUE_APP_API_URL}/${PLAYER_PROFILE_PHOTO_DEFAULT}`;
    });

    const resetProfilePhoto = () => {
      player.value.profilePhoto = null;
      player.value.flagCambioImagen = true;
      profileUrl.value = profileUrlDefault.value;
    };

    const triggerFileInput = (e?: Event) => {
      e?.preventDefault?.();
      e?.stopPropagation?.();
      fileInput.value?.click();
    };

    const onFileChange = (event: Event) => {
      const target = event.target as HTMLInputElement;
      if (target.files && target.files.length > 0) {
        const file = target.files[0];
        profileUrl.value = URL.createObjectURL(file);
        player.value.profilePhoto = file as any;
      }
    };

    const getCompanies = async () => {
      try {
        const response = await api.get(
          `/common/companies?type=${COMPANY_TYPES.PARTICIPANTE}`
        );
        itemsCompany.value = response.data;
      } catch (ex) {
        console.error(ex);
      }
    };

    const getDocumentType = async () => {
      try {
        const response = await api.get(
          `/common/document-type`
        );
        itemsDocumentType.value = response.data;
      } catch (ex) {
        console.error(ex);
      }
    };

    const handleUpdateFiles = (fileItems: any[]) => {
      player.value.profilePhoto = fileItems.length ? fileItems[0].file : null;
    };

    const validateForm = async () => {
      try {
        errors.value = {};
        await playerSchema.validate(player.value, {
          abortEarly: false,
          context: { id: player.value.id },
        });
        isLoading.value = true;

        await createPlayer();
        isLoading.value = false;
      } catch (err: any) {
        console.log("err: " + err);
        if (err.inner) {
          err.inner.forEach((e: any) => {
            errors.value[e.path] = e.message;
          });
        }
        isLoading.value = false;
      }
    };

    const clearError = (field: string) => {
      errors.value[field] = "";
    };

    const buildFormData = (data: any) => {
      const formData = new FormData();
      for (const key in data) {
        if (
          data[key] !== undefined &&
          data[key] !== null &&
          key != "createdBy"
        ) {
          formData.append(key, data[key]);
        }
      }
      return formData;
    };

    const getPlayerById = async (id: any) => {
      try {
        const response = await api.get(`/player/${id}`);
        const responseFormat = response.data;
        console.log(responseFormat.profilePhoto);
        if (responseFormat.profilePhoto) {
          profileUrl.value = `${process.env.VUE_APP_API_URL}/${responseFormat.profilePhoto}`;
        } else {
          profileUrl.value = `${process.env.VUE_APP_API_URL}/${PLAYER_PROFILE_PHOTO_DEFAULT}`;
        }
        player.value = responseFormat;
        player.value.oldEmail = player.value.email;
        if (player.value.birthdate) {
          player.value.birthdate =
            responseFormat.birthdateStr as unknown as null;
        }
        isEditMode.value = true;
        console.log(player);
      } catch (ex) {
        console.error(ex);
      }
    };

    const createPlayer = async () => {
      try {
        var pBirthdate = null;
        if (player.value.birthdate != null) {
          pBirthdate = moment(player.value.birthdate).format("YYYY-MM-DD");
        }

        const payload = {
          ...player.value,
          birthdate: pBirthdate,
        };

        const formData = buildFormData(payload);

        const response: any = await api.postForm(`/player`, formData);

        if (response.data.return) {
          toast.success(
            `El jugador fue ${player.value.id == 0 ? "creado" : "actualizado"
            } con éxito.`,
            {
              timeout: 2000,
            }
          );

          router.push({ name: "PlayersPage" });
        }
      } catch (ex) {
        toast.error("El jugador no pudo ser creado.", {
          timeout: 2000,
        });
        console.error(ex);
      }
    };

    const removeCoverFile = async () => {
      player.value.urlProfilePhoto = null;
    };

    return {
      handleUpdateFiles,
      createPlayer,
      validateForm,
      clearError,
      removeCoverFile,
      player,
      itemsCompany,
      itemsDocumentType,
      errors,
      isLoading,
      isEditMode,
      canEditAlias,
      canEditBirthdate,
      canEditParticipationReasons,
      es,
      profileUrl,
      fileInput,
      triggerFileInput,
      onFileChange,
      resetProfilePhoto,
    };
  },
});
</script>
